export default __webpack_public_path__ + "static/media/well_done.png";